import AdicionarEstagioModal from "../../modals/AdicionarEstagioModal"
import DesligarEstagiarioModal from "../../modals/DesligarEstagiarioModal"
import GerenciarEventosEstagioModal from "../../modals/GerenciarEventosEstagioModal"
import Links from "@/shared/constants/navegacao"
import ModalExcluir from "@/shared/components/modals/ModalExcluir"
import { CursoService } from "@/modules/structure/curso/curso.service"
import { DataAmigavel } from "@/shared/utils/datas"
import { ReadCursoDto, ReadEstagiarioEstagioDto, ReadInstituicaoEnsinoDto } from "@/api.types"
import { InstituicaoEnsinoService } from "@/modules/structure/instituicoes/instituicao.service"
import { Link } from "react-router-dom"
import { PersonProfilesFormMethods } from "./profile.types"
import { TipoLotacaoEstagioList } from "@/shared/constants/enumlist"
import { exportToDoc } from "@/shared/components/exportToDoc"
import { toast } from "react-toastify"
import { useFieldArray } from "react-hook-form"
import { useState, useEffect } from "react"
import { Tabs, Tab } from "react-bootstrap"
import { LotacaoService } from "@/modules/business/lotacoes/lotacao.service"
import { ReadLotacaoDto } from "@/api.types"
import { SearchDtoLotacoes } from "@/shared/types/search.dto"
import { LotacoesPerfilTable } from "./lotacoes-perfil-table"
import { FolhasPerfilTab } from "./folhas-perfil-tab"

interface EstagiarioProfileFieldsProps {
  methods: PersonProfilesFormMethods
}

export function EstagiarioProfileFields({ methods }: EstagiarioProfileFieldsProps) {
  const estagiarioId = methods.watch('estagiario.id')
  const estagiarioAtivo = methods.watch('estagiario.ativo')
  const estagios = methods.watch('estagiario.estagios')

  const { append, remove } = useFieldArray({
    control: methods.control,
    name: 'estagiario.estagios',
    keyName: '_id',
  })

  const cursoService = new CursoService();
  const instituicoesService = new InstituicaoEnsinoService();

  const [cursos, setCursos] = useState<ReadCursoDto[]>([]);
  const [instituicoes, setInstituicoes] = useState<ReadInstituicaoEnsinoDto[]>([]);

  const [idEstagioEdicao, setIdEstagioEdicao] = useState(0);
  const [indexEstagioRemover, setIndexEstagioRemover] = useState(-1);
  const [modalAdicionarEstagioShow, setModalAdicionarEstagioShow] = useState(false);
  const [modalDesligarShow, setModalDesligarShow] = useState(false);
  const [modalExcluirEstagioShow, setModalExcluirEstagioShow] = useState(false);
  const [lotacoesAtuais, setLotacoesAtuais] = useState<ReadLotacaoDto[]>([]);
  const [modalEventoShow, setModalEventoShow] = useState(false);
  const [idEstagioEvento, setIdEstagioEvento] = useState(0);

  useEffect(() => {
    Promise.all([
      cursoService.findAll({ skip: 0, take: 1000 }),
      instituicoesService.Enumerate(),
    ])
      .then((res) => {
        setCursos(res[0][0]);
        setInstituicoes(res[1]);
      })
      .catch((error) => {
        toast.error(error.message || 'Erro ao carregar dados.');
      });
  }, []);

  useEffect(() => {
    if (estagiarioId) {
      const lotacaoService = new LotacaoService();
      const searchParams: SearchDtoLotacoes = {
        skip: 0,
        take: 9000,
        id_estagiario: estagiarioId,
      } as SearchDtoLotacoes;

      lotacaoService
        .Enumerate(searchParams)
        .then((result) => {
          setLotacoesAtuais(result[0]);
        })
        .catch((error) => {
          console.warn('Erro ao carregar lotações:', error);
        });
    } else {
      setLotacoesAtuais([]);
    }
  }, [estagiarioId]);

  const handleEditarEstagio = (index: number) => {
    setIdEstagioEdicao(index);
    setModalAdicionarEstagioShow(true);
  };

  const abrirModalAdicionarEstagio = () => {
    setIdEstagioEdicao(-1);
    setModalAdicionarEstagioShow(true);
  };

  const handleExcluirEstagio = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (indexEstagioRemover >= 0) remove(indexEstagioRemover);
    setModalExcluirEstagioShow(false);
  };

  const abrirModalEvento = (idEstagio: number) => {
    setIdEstagioEvento(idEstagio);
    setModalEventoShow(true);
  };

  return (
    <>
      <div className="mb-3 col-md-4">
        <label htmlFor="estagiario_anotacao" className="form-label">Anotações:</label>
        <input
          id="estagiario_anotacao"
          type="text"
          className="form-control"
          {...methods.register('estagiario.anotacao')}
        />
      </div>

      <div className="mt-3">
        <Tabs
          defaultActiveKey="estagios"
          id="estagiario-perfil-tabs"
          className="mb-2"
          mountOnEnter
          unmountOnExit
        >
          <Tab eventKey="estagios" title="Estágios">
            <div className="mb-3 d-flex flex-wrap justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={abrirModalAdicionarEstagio}
                title="Adicionar novo estágio"
              >
                Adicionar Estágio
              </button>
              {estagiarioAtivo ? (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => setModalDesligarShow(true)}
                  title="Definir data de desligamento, inativar perfil e desabilitar acesso"
                >
                  Desligar Estagiário
                </button>
              ) : null}
            </div>

            <table className="table table-sm table-bordered table-hover table-striped text-center mb-0">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Curso</th>
                  <th>Colação de Grau</th>
                  <th>Fim de Semana</th>
                  <th>Início do Estágio</th>
                  <th>Fim do Estágio</th>
                  <th>Desligamento</th>
                  <th>Ações</th>
                  <th>Registro</th>
                </tr>
              </thead>
              <tbody>
                {estagios &&
                  estagios.map((estagio, index) => {
                    let exibida = '';
                    if (estagio.data_colacao_grau) {
                      const [ano, mes] = String(estagio.data_colacao_grau).split('-');
                      const dataColacao = new Date(
                        new Date(Number(ano), Number(mes) - 1).toUTCString(),
                      );
                      exibida = dataColacao.toLocaleDateString('pt-BR', {
                        month: 'long',
                        year: 'numeric',
                      });
                    }

                    return (
                      <tr key={index}>
                        <td>
                          {TipoLotacaoEstagioList.find((a) => a.value == estagio.tipo_estagio)?.name}
                        </td>
                        <td>{cursos.find((a) => a.id == estagio.curso?.id)?.nome}</td>
                        <td>{exibida}</td>
                        <td>{estagio.fim_semana ? 'Sim' : 'Não'}</td>
                        <td>{DataAmigavel(estagio.data_inicio_estagio)}</td>
                        <td>{DataAmigavel(estagio.data_fim_estagio)}</td>
                        <td>{DataAmigavel(estagio.desligamento)}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm me-2 mb-2"
                            onClick={() => exportToDoc(methods.getValues(), estagio)}
                            title="Termo de compromisso para esse estágio."
                          >
                            Termo
                          </button>
                          {estagio.id > 0 && (
                            <Link
                              to={Links.Vinculos_Index + '?tipo=estagiario'}
                              className="btn btn-sm btn-outline-success mb-2"
                              title="Ir à página de lotação;"
                            >
                              Vínculos
                            </Link>
                          )}
                          {estagio.id > 0 && (
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-info mb-2 ms-2"
                              title="Gerenciar eventos (férias, folgas, abonos)"
                              onClick={() => abrirModalEvento(estagio.id)}
                            >
                              Eventos
                            </button>
                          )}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-dark me-2 mb-2"
                            onClick={() => handleEditarEstagio(index)}
                          >
                            Editar
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm mb-2"
                            title="Remover esse estágio."
                            onClick={() => {
                              setIndexEstagioRemover(index);
                              setModalExcluirEstagioShow(true);
                            }}
                          >
                            Excluir
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </Tab>

          <Tab eventKey="lotacoes" title="Lotações">
            <LotacoesPerfilTable
              lotacoes={lotacoesAtuais}
              emptyMessage="Nenhuma lotação cadastrada para este estagiário."
              incluirTiposEstagio
            />
          </Tab>

          <Tab eventKey="folhas" title="Folhas">
            <FolhasPerfilTab estagiarioId={estagiarioId} />
          </Tab>
        </Tabs>
      </div>

      {modalAdicionarEstagioShow && (
        <AdicionarEstagioModal
          show={modalAdicionarEstagioShow}
          handleHide={() => setModalAdicionarEstagioShow(false)}
          cursos={cursos}
          instituicoes={instituicoes}
          initialData={
            idEstagioEdicao >= 0
              ? methods.getValues(`estagiario.estagios.${idEstagioEdicao}`)!
              : ({} as ReadEstagiarioEstagioDto)
          }
          estagioIndex={idEstagioEdicao}
          appendEstagio={append}
          setValue={methods.setValue}
          getValues={methods.getValues}
        />
      )}

      {modalDesligarShow && (
        <DesligarEstagiarioModal
          show={modalDesligarShow}
          handleHide={() => setModalDesligarShow(false)}
          getValues={methods.getValues}
          setValue={methods.setValue}
        />
      )}

      <ModalExcluir
        show={modalExcluirEstagioShow}
        handleExcluir={handleExcluirEstagio}
        handleHide={() => setModalExcluirEstagioShow(false)}
      />

      {modalEventoShow && idEstagioEvento > 0 && (
        <GerenciarEventosEstagioModal
          show={modalEventoShow}
          handleHide={() => {
            setModalEventoShow(false);
            setIdEstagioEvento(0);
          }}
          idEstagio={idEstagioEvento}
        />
      )}
    </>
  )
}

/** @deprecated Use OperationalProfilesSection */
export function EstagiarioProfile({
  methods,
  podeVerEstagiario,
}: {
  methods: PersonProfilesFormMethods;
  podeVerEstagiario: boolean;
}) {
  if (!podeVerEstagiario) return null;
  return <EstagiarioProfileFields methods={methods} />;
}
